<template>
  <div class="main">
    <HeaderTitle title="Scene">
      <IconDate color="#14444f" size="w-10 h-10" />
    </HeaderTitle>
    <MainContent>
      <div class="pb-5">
        <FullCalendar
          class="fullCalendar px-5 py-5 bg-gray-100"
          id="fullCalendar"
          ref="calendar"
          :options="calendarOptions"
        >
          <template v-slot:eventContent="sch">
            <span
              class="text-gray-500 font-semibold text-center text-xs py-3"
              v-if="calView == 'dayGridMonth'"
            >
              {{ sch.event.title }} Scene
            </span>
            <!-- <div class="flex items-end justify-end">
              <button class="bg-blue-500 hover:bg-blue-600 p-1 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-4 h-4"
                  @click="download"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12 2.25a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3a.75.75 0 0 1 .75-.75Zm-9 13.5a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div> -->
          </template>
        </FullCalendar>
      </div>
    </MainContent>
  </div>
  <div id="loading-overlay" v-if="countByDate.loading">
    <LoadingLoad id="loading" class="" size="w-14 h-14" />
  </div>
</template>
<script>
import HeaderTitle from "@/components/HeaderTitle.vue";
import IconDate from "@/components/icons/IconDate.vue";
import MainContent from "@/components/MainContent.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import multiMonthPlugin from "@fullcalendar/multimonth";
import LoadingLoad from "@/components/LoadingLoad.vue";
import { reactive, ref, watch } from "vue";
import { useOrderStore } from "@/store";
import { storeToRefs } from "pinia";

export default {
  components: {
    HeaderTitle,
    IconDate,
    MainContent,
    FullCalendar,
    LoadingLoad,
  },
  setup() {
    const orderStore = useOrderStore();
    const { countByDate } = storeToRefs(orderStore);

    const calendar = ref(null);

    const countData = ref([]);
    const calView = ref("dayGridMonth");
    const sum = ref(0);

    let lastMonth = null;
    let lastYear = null;

    const updateCustomButton = (value) => {
      const calendarApi = calendar.value?.getApi();
      if (!calendarApi) return;

      calendarApi.setOption("customButtons", {
        myCustomButton: {
          text: `Total: ${value.toLocaleString("id-ID")} Scene`,
        },
      });
    };

    const calendarOptions = reactive({
      plugins: [dayGridPlugin, multiMonthPlugin],
      initialView: "dayGridMonth",
      events: [],
      selectable: true,
      dayMaxEvents: true,
      weekends: true,

      customButtons: {
        myCustomButton: {
          text: `Total: 0 Scene`,
        },
      },

      headerToolbar: {
        left: "myCustomButton",
        center: "title",
        right: "prev,today,next,multiMonthYear",
      },

      datesSet: () => {
        const calendarApi = calendar.value.getApi();
        const viewType = calendarApi.currentData.currentViewType;

        if (viewType === "multiMonthYear") {
          calView.value = "multiMonthYear";
          updateCustomButton(0);

          const headers = document.querySelectorAll(".fc-multimonth-title");
          headers.forEach((el) => {
            el.style.cursor = "pointer";
            el.onclick = () => {
              const yearText = document
                .querySelector(".fc-toolbar-title")
                ?.innerText.trim();
              const monthName = el.innerText.trim();
              const monthIndex = new Date(
                `${monthName} 1, ${yearText}`
              ).getMonth();
              calendarApi.changeView("dayGridMonth");
              calendarApi.gotoDate(new Date(yearText, monthIndex, 1));
            };
          });
        } else {
          calView.value = "dayGridMonth";

          const currentDate = calendarApi.getDate();
          const m = currentDate.getMonth() + 1;
          const y = currentDate.getFullYear();

          if (m !== lastMonth || y !== lastYear) {
            lastMonth = m;
            lastYear = y;
            getCountByDate(y, m);
          }

          updateCustomButton(sum.value);
        }
      },
    });

    const getCountByDate = async (year, month) => {
      const calendarApi = calendar.value?.getApi();
      countData.value = [];
      sum.value = 0;

      await orderStore.getCountByDate({ year, month });

      const result = countByDate.value.result || [];

      result.forEach((item, index) => {
        countData.value.push({
          id: index + 1,
          title: item.scene_count,
          start: item.scene_date,
          allDay: true,
          color: "#00000000",
        });

        sum.value += parseInt(item.scene_count);
      });

      calendarApi.removeAllEvents();
      calendarApi.addEventSource(countData.value);

      updateCustomButton(sum.value);
    };

    watch(sum, (newVal) => {
      updateCustomButton(newVal);
    });

    const download = () => {
      console.log("download scene");
    };

    return {
      calendar,
      calendarOptions,
      countByDate,
      download,
      calView,
    };
  },
};
</script>
<style>
.fc-event-main {
  display: grid !important;
}
#loading-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.016);
  z-index: 10;
  backdrop-filter: blur(1px);
}
#loading {
  position: absolute;
  top: 55%;
  left: 43%;
  transform: translate(-50%, -50%);
}

.fc .fc-myCustomButton-button {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #6b7280 !important;
  font-weight: 600;
  font-size: 13px;
  line-height: 1rem;
  margin-top: 20px;
  cursor: text !important;
  pointer-events: none;
}

.fc .fc-myCustomButton-button:hover,
.fc .fc-myCustomButton-button:focus {
  background: transparent !important;
  color: #6b7280 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
